import React from "react";
import loadingScreen from "../../assets/img/loader4.gif";

const LoadingMessage = () => {
  return (
    <div>
      <div className="card chatting-box mb-0">
        <div
          style={{
            display: "grid",
            gridGap: "1rem",
            padding: "1rem",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
            alignContent: "center",
            justifyItems: "center",
          }}
        >
          <span>
            <img style={{ width: "80px" }} src={loadingScreen} alt="logo" />
          </span>
          <span>Getting your history...</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingMessage;
